// Service Worker anmelden (nur im gebauten Stand). Er hält ausschließlich die App-Dateien vor, nie Daten.
// Neue Version: stündlich und beim Zurückkehren ins Fenster nachsehen; ist der neue Service Worker aktiv (skipWaiting),
// meldet `neueVersion` das der Oberfläche – neu geladen wird nur auf Klick.

const STUENDLICH = 60 * 60 * 1000;
const FRUEHESTENS = 60 * 1000; // beim Zurückkehren ins Fenster höchstens einmal je Minute nachsehen

let da = false;
const hoerer = new Set<() => void>();

/** Steht eine neue Version bereit? Beobachten liefert eine Abmeldefunktion. */
export const neueVersion = {
  da: () => da,
  beobachten: (fn: () => void) => (hoerer.add(fn), () => void hoerer.delete(fn)),
};

function melden() {
  if (da) return;
  da = true;
  hoerer.forEach((fn) => fn());
}

export function serviceWorkerRegistrieren() {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  const starten = async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
      // Neue Version = neuer Worker, während schon einer aktiv ist (die erste Installation zählt nicht).
      // Nicht über controllerchange: WebKit setzt navigator.serviceWorker.controller beim Laden erst verzögert.
      reg.addEventListener('updatefound', () => {
        const neu = reg.installing;
        if (!neu || !reg.active) return;
        neu.addEventListener('statechange', () => { if (neu.state === 'activated') melden(); });
      });
      let zuletzt = Date.now();
      const nachsehen = () => {
        if (da || Date.now() - zuletzt < FRUEHESTENS) return;
        zuletzt = Date.now();
        reg.update().catch(() => { /* offline: beim nächsten Mal */ });
      };
      setInterval(() => { zuletzt = 0; nachsehen(); }, STUENDLICH);
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') nachsehen(); });
      window.addEventListener('focus', nachsehen);
    } catch (e) {
      console.warn('Service Worker nicht registriert:', e);
    }
  };
  // Nach dem Laden der Seite; ist sie schon geladen, sofort
  if (document.readyState === 'complete') void starten();
  else window.addEventListener('load', () => void starten());
}
